import styled from 'styled-components'

export const ScheduleWrapper = styled.div`
	padding: 20px 300px;
	display: flex;
	flex-direction: column;
	gap: 20px;
	min-width: 360px;

	@media (max-width: 1700px) {
		padding: 20px 220px;
	}
	@media (max-width: 1550px) {
		padding: 20px 130px;
	}
	@media (max-width: 1350px) {
		padding: 20px 80px;
	}
	@media (max-width: 1250px) {
		padding: 20px 50px;
	}
	@media (max-width: 700px) {
		padding: 20px 12px;
	}
`

export const ScheduleHeader = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 10px;

	h2 {
		font-size: 24px;
		font-weight: 600;
		color: #222222;
		letter-spacing: -1px;
		margin: 0;
	}
`

export const AddButton = styled.button`
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 10px 20px;
	background-color: #F78B85;
	color: #fff;
	border: none;
	border-radius: 4px;
	font-size: 14px;
	font-weight: 500;
	cursor: pointer;
	transition: background-color 0.3s;

	&:hover {
		background-color: #F06B64;
	}
`

export const CalendarContainer = styled.div`
	background-color: #fff;
	border: 3px solid #F1EBEB;
	border-radius: 8px;
	padding: 20px;
	
	.ant-picker-calendar {
		background-color: transparent;
	}

	.ant-picker-calendar-date {
		border: 1px solid #F6F1F1;
	}

	.ant-picker-calendar-date-content {
		height: auto;
		min-height: 60px;
	}
`

export const ScheduleList = styled.div`
	background-color: #fff;
	border: 3px solid #F1EBEB;
	border-radius: 8px;
	padding: 20px;
	min-height: 200px;

	h3 {
		font-size: 18px;
		font-weight: 600;
		color: #222222;
		margin-bottom: 16px;
		letter-spacing: -1px;
	}
`

export const ScheduleItem = styled.div<{ color: string }>`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	padding: 16px;
	margin-bottom: 12px;
	border-left: 4px solid ${props => props.color};
	border-radius: 4px;
	background-color: #FAFAFA;
	transition: background-color 0.3s;

	&:hover {
		background-color: #F5F5F5;
	}

	.schedule-content {
		flex: 1;

		h4 {
			font-size: 16px;
			font-weight: 600;
			color: #222222;
			margin: 0 0 8px 0;
			letter-spacing: -1px;
		}

		p {
			font-size: 14px;
			color: #666666;
			margin: 0 0 8px 0;
			line-height: 1.5;
		}

		.schedule-meta {
			display: flex;
			flex-direction: column;
			gap: 4px;
			font-size: 12px;
			color: #999999;

			span {
				letter-spacing: -0.5px;
			}
		}
	}

	.schedule-actions {
		display: flex;
		gap: 8px;

		button {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 32px;
			height: 32px;
			border: 1px solid #D9D9D9;
			background-color: #fff;
			border-radius: 4px;
			cursor: pointer;
			transition: all 0.3s;
			color: #666;

			&:hover {
				border-color: #F78B85;
				color: #F78B85;
			}

			&:last-child:hover {
				border-color: #ff4d4f;
				color: #ff4d4f;
			}
		}
	}
`

export const ModalContent = styled.div`
	padding: 20px 0;
`







